import axios from './axios';

const walletService = {
  getWalletList: async () => {
    const response = await axios.get('/customer-wallet');
    return response.data;
  },
  createCard: async (cardData) =>{
    const response = await axios.post('/customer-wallet', cardData);
    return response.data;
  },
  deleteCard: async (id)=>{
    const response = await axios.delete(`/customer-wallet/${id}`);
    return response.data;
  },
  setDefault: async (id)=>{
    const response = await axios.post(`customer-wallet/${id}/set-default`)
    return response.data;
  }

};

export default walletService;